export default "; datasetFetch\n(fn [dataset samples probes]\n  (fetch [{:table dataset\n           :columns probes\n           :samples samples}]))\n";